import { Component, ElementRef } from '@angular/core';
import { BookingModel, BookingService, LayoutService, NavigationService } from 'app-components';
import { AppIntegrationService, AppSettingsService, AppTypeSettings } from 't4-app-integration';
import { PageBase, TypeCategoryInfo } from 't4core';
import { Country, getCountryByLanguageCode, getCountryDataByName } from '../../../../lib/Models/Country';
import { Subscription } from 'rxjs';
import { AppPageBase } from 'app-components';

@Component({
    selector: 'select-family-component',
    templateUrl: './select-family-type.html',
    styleUrls: ['./select-family-type.css'],
    standalone: false
})
export class SelectFamilyType extends AppPageBase {

  public filterdCategoryList: TypeCategoryInfo[] = [];
  public typeCategoryList: TypeCategoryInfo[] = [];

  public oneWayConcept: TypeCategoryInfo = null;

  public atLocationCategoryList: string[] = [];
  public typeSettings: AppTypeSettings;
  public userClosed: boolean = false;
  public firstVisitOverlay: boolean = false;
  public language: string = this.appSettings.getLanguage();
  public filterCountry: Country;

  public isSingleStation: boolean = false;

  public loading: boolean = false;

  private appSettingsSubscription: Subscription;
 
  constructor(private navigator: NavigationService, el: ElementRef, private appService: AppIntegrationService, public layout: LayoutService, public appSettings: AppSettingsService, private bookingSvc: BookingService) {
    super(el, "SelectFamilyType");
    this.typeSettings = this.appSettings.typeSettings;
    this.userClosed = localStorage.getItem('newInfoClosed') ? true : false;
  }

  async ngOnInit() {
    this.loading = true;

    // Display overlay on first visit.
    if (!localStorage.getItem('hasSeenTrailerHint')) {
      this.firstVisitOverlay = true;
      document.body.classList.add('global-overlay-active');

    }

    // Start a new booking session
    await this.bookingSvc.startSession();

    //If its a single station, we skip the map/location selector.
    this.isSingleStation = this.appSettings.isSingleStation;

   

    // Skip this step if location is already selected
    if (this.appSettings.getParam("pickupLocationId")) {
      this.navigator.executeCommand("Map");
    } 

    // Load the initial set of families
    await this.loadObjectFamilies();

    // Handle changes to anticipated countries
    this.appSettingsSubscription = this.appSettings.anticipatedCountryChanged.subscribe(async () => {
      await this.loadObjectFamilies();
    })

    this.loading = false;

    if (this.isSingleStation) {
      var locations = await this.bookingSvc.getLocations();
      this.bookingSvc.setLocations(locations[0]);
    }
  }

  async ngOnDestroy() {
    // Tidy up all subscriptions
    document.body.classList.remove('global-overlay-active');
    this.appSettingsSubscription.unsubscribe();
  }


  private checkOnStationSingleCategory() {
    if (this.userClosed && this.appSettings.skippedToMap) return;

    this.appService.getCoordinates()
      .then(currentCoordinates => {
        if (!currentCoordinates) return null;

        return this.bookingSvc.findSingleClosetLocationWithinDistance(
          currentCoordinates, 500, 1000
        );
      })
      .then(closestLocation => {
        if (!closestLocation) return;

        if (closestLocation.HasFamilies && closestLocation.HasFamilies !== "") {
          const categories = closestLocation.HasFamilies.split(';').filter(Boolean);

          if (categories.length === 1) {
            this.appSettings.skippedToMap = true;
            this.skip();
          } else {
            this.atLocationCategoryList = categories;
          }
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  public toggleFirstVisit(show: boolean) {
    this.firstVisitOverlay = show;
    if (!show) {
      localStorage.setItem('hasSeenTrailerHint', 'true');
      document.body.classList.remove('global-overlay-active');
    }
  }


  // Load families from database and applies the relevant filters
  private async loadObjectFamilies() {
    this.typeCategoryList = await this.bookingSvc.getCategories();
    console.log("categories", this.typeCategoryList)
    this.checkOnStationSingleCategory();

    //Extract Oneway Concept if exists
    this.oneWayConcept = this.typeCategoryList.find(category => category.Name === 'Oneway') || null;
    console.log("oneWayConcept", this.oneWayConcept);

    //Remove Oneway from the default list, to add special function.
    if (this.oneWayConcept != null) {
      this.typeCategoryList = this.typeCategoryList.filter(
        item => item.Name !== 'Oneway'
      );
    }


    if (this.atLocationCategoryList && this.atLocationCategoryList.length != 0) {

    //  this.filterdCategoryList = this.typeCategoryList.filter(item =>
    //    this.atLocationCategoryList.includes(item.Id));
    }
    else { 

    //Check if we have set a anticipated country, if we cold loaded into the map. etc
    //Location
    //Lanuguage
    //Brower Language
    var country = this.appSettings.getAnticipatedUserCountry();
    if (country) {
      this.filterCountry = getCountryDataByName(country);
    } else {
      this.filterCountry = null;
    }

    //Filters on the Context, If they dont have a selected cotunry then it would be shown for all.
    //Set EN as a show all option for now.
    if (this.filterCountry) {
      this.filterdCategoryList = this.typeCategoryList.filter(x => {
        return x.Countries == undefined || x.Countries.length == 0 || x.Countries.indexOf(this.filterCountry.shortName.toUpperCase()) !== -1
      })
    } else {
      this.filterdCategoryList = this.typeCategoryList;
      }
    }
  }

  // Handles the selection of an object family
  public selectType(category: TypeCategoryInfo) {
    if (this.firstVisitOverlay) {
      this.toggleFirstVisit(false);
    }

    var state = this.bookingSvc.getBookingState();
    state.objectCategory = category;
    this.bookingSvc.saveState(state);

    if (this.isSingleStation) {
      this.skipToTime();
    }
    else {
      this.executeCommand("Map");
    }
  }

  public back() {
    this.navigator.back();
  }

  public skip() {
    this.executeCommand("Map");
  }

  public mybooking() {
    let user = this.appSettings.userId;
    if (!user) {
      this.executeCommand("SignIn");
    }
    else {
      this.executeCommand("Bookings");
    }
  }

  public toggleNewUserInfo(bool = true) {
    localStorage.setItem('newInfoClosed', 'true');
    this.userClosed = bool;
  }

  public async skipToTime() {
    this.executeCommand("TimeSelector");


  }

  public async openOneWay() {
    var x = await this.UI.confirm("Intellitrailer.Booking.SelectFamilyType.SwitchToOneway.Headline", "Switch to Oneway App", "Intellitrailer.Booking.SelectFamilyType.SwitchToOneway.Message", "Do you want to open the oneway app?");
    if (!x) return;
    if (this.Settings.Environment == 0) {
      window.location.href = 'https://api.turbo4.net/Links/Apps/oneway';
    } else {
      //window.open('https://api-test.turbo4.net/Links/Apps/oneway', '_blank');
      window.location.href = 'https://api-test.turbo4.net/Links/Apps/oneway';
    }
    
  }
}

